module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/usb-line.b2e580e8.png";